import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { Link, RouterProvider, createRouter } from "@tanstack/react-router";
// Import the generated route tree
import { routeTree } from "./routeTree.gen";
import { QueryClient } from "@tanstack/react-query";
import { setupRouterSsrQueryIntegration } from "@tanstack/react-router-ssr-query";
import { Button } from "@op/sf-editor";

const NotFoundComponent = () => {
  return (
    <div className="flex flex-col min-h-screen items-center justify-center gap-4">
      <div className="flex flex-col items-center justify-center gap-2">
        <h1 className="text-heading-1 font-heading-1 text-subtext-color">
          404
        </h1>
        <p className="text-body font-body text-default-font">Page not found</p>
      </div>
      <Link className="contents" to="/">
        <Button variant="brand-secondary">Back to safety</Button>
      </Link>
    </div>
  );
};

const ErrorComponent = () => {
  return (
    <div className="flex flex-col min-h-screen items-center justify-center gap-2">
      <div className="flex flex-col items-center justify-center gap-2">
        <h1 className="text-heading-1 font-heading-1 text-subtext-color">
          500
        </h1>
        <p className="text-body font-body text-default-font">
          Something went wrong on our end. Please try again later or contact us.
        </p>
      </div>
      <Link className="contents" to="/">
        <Button variant="brand-secondary">Back to safety</Button>
      </Link>
    </div>
  );
};

function getRouter() {
  const queryClient = new QueryClient();
  const router = createRouter({
    routeTree,
    // optionally expose the QueryClient via router context
    context: { queryClient },
    defaultPreload: "intent",
    defaultNotFoundComponent: NotFoundComponent,
    defaultErrorComponent: ErrorComponent,
  });

  setupRouterSsrQueryIntegration({
    router,
    queryClient,
    wrapQueryClient: true,
  });

  return router;
}

// Create a new router instance
const router = getRouter();

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// Render the app
const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>,
  );
}
